module.exports = __webpack_public_path__ + "img/tip.5d7194df.png";